/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @typescript-eslint/no-explicit-any */
import IconComponent from 'components/common/IconComponent';
import { DEFAULT_FORMAT_DATE_US } from 'constants/days';
import deviceSizes from 'constants/deviceSizes';
import useInfiniteMessageQuery from 'hooks/useInfiniteMessageQuery';
import moment from 'moment';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SelectedAppointmentContactAction from 'redux/selected-contact/selected-contact.action';
import SelectedAppointmentContactSelectors from 'redux/selected-contact/selected-contact.selectors';
import { GeneralFunction } from 'types/common';

import ChatWindow from '../ ChatWindow';

const ChatBoxConversation: React.FC<{
  // messages?: IMessage[];
  refetchChatRoomData: GeneralFunction;
  // fetchMoreMessage: GeneralFunction;
  loading?: boolean;
  // conversationsData?: IMessage[];
  forceRender?: boolean;
}> = ({ refetchChatRoomData, forceRender }) => {
  const selectedAppointmentContact = useSelector(SelectedAppointmentContactSelectors.selectAppointmentContact);
  const {
    description: selectedAppointmentContactDescription,
    id: selectedChatRoomId,
    date: selectedAppointmentContactDate,
    chatRoom,
  } = selectedAppointmentContact;
  const selectedAppointmentContactDateString = selectedAppointmentContactDate
    ? moment(selectedAppointmentContactDate).format(DEFAULT_FORMAT_DATE_US).toString()
    : '';
  const dispatch = useDispatch();

  const {
    data: messages,
    loading: messageLoading,
    oldMessageLoading,
    oldMessageData,
    fetchOldMessages,
    subscribeToMessages,
  } = useInfiniteMessageQuery({
    chatRoomId: selectedChatRoomId,
  });

  useEffect(() => {
    const unsub = subscribeToMessages(selectedChatRoomId || '');
    return () => unsub();
  }, [selectedChatRoomId]);

  const deSelectContact = () => {
    dispatch(SelectedAppointmentContactAction.deselectAppointmentContact());
  };

  if (!selectedChatRoomId && !forceRender) return null;

  return (
    <ChatWindow
      oldMessages={oldMessageData}
      oldMessageLoading={oldMessageLoading}
      loading={messageLoading}
      messages={messages}
      fetchNextPageMessage={fetchOldMessages}
      chatRoom={chatRoom}
      refetchChatRoomData={refetchChatRoomData}
      mobileThreshold={deviceSizes.numbers.md}
      header={
        <div className='chatbox-general-header'>
          <div className='back-icon md:!hidden' onClick={deSelectContact}>
            <IconComponent name='chevron-left' size={14} />
          </div>
          <div>
            <span>{selectedAppointmentContactDescription || 'Notary Appointment'}</span>
            {selectedAppointmentContactDateString && <span> - {selectedAppointmentContactDateString}</span>}
          </div>
        </div>
      }
    />
  );

  // return (
  //   <>
  //     <div className='chatbox-general-header'>
  //       <div className='back-icon sm:hidden' onClick={deSelectContact}>
  //         <IconComponent name='chevron-left' size={14} />
  //       </div>
  //       <div>
  //         <span>{selectedAppointmentContactDescription || 'Notary Appointment'}</span>
  //         {selectedAppointmentContactDateString && <span> - {selectedAppointmentContactDateString}</span>}
  //       </div>
  //     </div>
  //     <div
  //       className='chatboxes'
  //       onScroll={onScroll}
  //       ref={(ref) => {
  //         if (!ref || !messages) return;
  //         chatWindowRef.current = ref;
  //       }}>
  //       {loading && !!messages && (
  //         <div style={{ height: 50 }}>
  //           <CircularProgress />
  //         </div>
  //       )}
  //       {messages &&
  //         messages.length > 0 &&
  //         mapRight(messages, (message) => <ChatCard key={message.id} message={message} />)}
  //       {/* loading for first fetch of messages */}
  //       {!messages && loading && <CircularProgress />}
  //     </div>
  //     <div className='chat-input'>
  //       <Formik innerRef={formRef} onSubmit={sendMessageToOther} initialValues={{ chat: '' }}>
  //         <Form autoComplete='off'>
  //           <div className='chat-input'>
  //             <div className='gx-flex-1' onFocus={readMessageOnInputFocus}>
  //               <InputComponent type={INPUT_TYPE.TEXT} name='chat' />
  //             </div>
  //             <ButtonWithSpinner htmlType='submit' width='auto' border='none' buttonType='text'>
  //               <div className='gx-d-flex gx-align-items-center'>
  //                 <IconComponent name='chat-bubble' />
  //               </div>
  //             </ButtonWithSpinner>
  //           </div>
  //         </Form>
  //       </Formik>
  //     </div>
  //   </>
  // );
};

export default ChatBoxConversation;
